import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
// media query
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';


export const  LargeModal = ({open,close,title,clickOutside,children}) => {
    // media query
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: matches?'80%':'90%',
        bgcolor: 'background.paper',
        borderRadius:'10px',
        //   border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    return (
        <div>
        <Modal
            open={open}
            onClose={clickOutside?close:''}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography sx={{mb:2}}>{title}</Typography>
            {children}
            </Box>
        </Modal>
        </div>
    );
}